// The 'query' workaround might not be used at all in the project.
// Left it here because it might be useful in the future.
function mergeSplittedFields(input, schema) {
  const copies = [];
  const clean = [];
  const newInput = { ...input };

  Object.keys(schema.properties).forEach((property) => {
    if (schema.properties[property] && schema.properties[property].query) {
      copies.push({
        fields: [schema.properties[property].query, property],
        into: schema.properties[property].query,
      });
      clean.push(property);
    }
  });

  copies.forEach((copy) => {
    newInput[copy.into] = [...new Set([...input[copy.fields[0]], ...input[copy.fields[1]]])];
  });
  clean.forEach((cl) => {
    delete newInput[cl];
  });
  return newInput;
}

export default mergeSplittedFields;



// WEBPACK FOOTER //
// ./src/byob-cms/src/formLib/mergeSplittedFields.js